import { render, staticRenderFns } from "./medHospital.vue?vue&type=template&id=7bb3d3ab"
import script from "./medHospital.vue?vue&type=script&lang=js"
export * from "./medHospital.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports